/**
 * Visual Currency Converter - v15.0 (Shipping Bar Fix)
 * Adds support for custom shipping progress bar amount.
 */
class CurrencyConverterSmart {
  constructor() {
    this.rate = 943; // Актуальный курс
    this.activeCurrency = 'USD';
    // --- ИЗМЕНЕНИЕ ЗДЕСЬ: Добавлен новый селектор ---
    this.priceSelectors = '.money, .price, .m-price-item, .m-progress-bar__amount';
    this.storageKey = 'user_preferred_currency_v15'; // Обновлен ключ для сброса
    this.debounceTimer = null;

    this.init();
  }

  init() {
    const configEl = document.querySelector('[data-currency-config]');
    if (configEl) {
      try {
        const config = JSON.parse(configEl.textContent);
        this.rate = config.exchangeRate || this.rate;
      } catch (e) {
        console.error('Currency Converter: Could not parse currency config.');
      }
    }

    this.setupClickListener();

    const savedCurrency = localStorage.getItem(this.storageKey) || 'USD';
    this.activeCurrency = savedCurrency;

    document.addEventListener('DOMContentLoaded', () => {
      if (this.activeCurrency === 'CLP') {
        this.runFullConversion();
        this.setupObserver();
      }
      this.updateDisplay();
    });
  }

  setupClickListener() {
    document.body.addEventListener('click', (e) => {
      const option = e.target.closest('.m-currency-switcher .m-select-custom--option');
      if (option && option.dataset.value) {
        e.preventDefault();
        e.stopPropagation();
        
        const newCurrency = option.dataset.value;
        const currentCurrency = localStorage.getItem(this.storageKey) || 'USD';

        if (currentCurrency !== newCurrency) {
          localStorage.setItem(this.storageKey, newCurrency);
          window.location.reload();
        }
      }
    }, true);
  }

  setupObserver() {
    const observer = new MutationObserver((mutations) => {
      const needsReconversion = mutations.some(mutation => 
        Array.from(mutation.addedNodes).some(node => 
          node.nodeType === 1 && (node.matches(this.priceSelectors) || node.querySelector(this.priceSelectors))
        )
      );

      if (needsReconversion) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          this.runFullConversion();
        }, 150);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  runFullConversion() {
    console.log('Currency Converter: Running full conversion to CLP.');
    this.restoreOriginals();
    this.applyConversion();
  }

  applyConversion() {
    document.querySelectorAll(this.priceSelectors).forEach(el => {
      if (!el.dataset.originalHtml) {
        el.dataset.originalHtml = el.innerHTML;
      }

      const originalHtml = el.dataset.originalHtml;
      // Используем более надежный regex, который найдет цену даже с символом валюты
      const priceMatch = originalHtml.match(/(\$\s*[\d,]+\.?\d*)/);

      if (priceMatch) {
        // Извлекаем только числовое значение
        const numberString = priceMatch[0].replace(/[^0-9.]/g, '');
        const usdValue = parseFloat(numberString);

        if (!isNaN(usdValue)) {
          const clpValue = Math.round(usdValue * this.rate);
          const formattedCLP = `$${clpValue.toLocaleString('es-CL')}`;
          el.innerHTML = originalHtml.replace(priceMatch[0], formattedCLP);
        }
      }
    });
  }

  restoreOriginals() {
    document.querySelectorAll('[data-original-html]').forEach(el => {
      el.innerHTML = el.dataset.originalHtml;
    });
  }

  updateDisplay() {
    const display = document.querySelector('.m-currency-switcher [data-currency-display]');
    if (display) {
      display.textContent = `${this.activeCurrency} ($)`;
    }
  }
}

// Запускаем скрипт
new CurrencyConverterSmart();